import { IntlShape } from 'react-intl';

/* Extract error message form AJAX call response. */
/* If no message is given, return a generic error message. */
export const getErrorMessage = (
  response: ThrownTypeResponse,
  formatMessage: IntlShape['formatMessage'],
) => {
  const { data } = response;
  if (data) {
    if (data.error_message) {
      return data.error_message;
    }
    if (data.error) {
      return formatMessage({ id: data.error });
    }
  }
  return formatMessage({ id: 'GENERIC_ERROR_MESSAGE' });
};
